import db from '../../firebase/firebaseconfig'

import router from '@/router'

import {createLog} from '@/repositories/admin.repository'

import adminStore from "@/store/admin.store"

const admin = adminStore.getters.admin;

const totensRef = db.firestore().collection('totens')

export const getTotensRepository = async () => {
  const totensDb = []
  const totens = []
  try {
    const snapshot = await totensRef.get()

    if (snapshot.empty) {
      return
    }

    snapshot.forEach(doc => {
      totensDb.push({
        id: doc.id,
        ...doc.data()
      })
    })
   
    if (admin.totens.length) {
      admin.totens.forEach(totem => {
        totensDb.forEach(totenDb => {
          if (totenDb.id === totem) {
          totens.push(totenDb)
          }
        })
      })
    }

    return totens;

  } catch (error) {
    console.log(error)
  }
}

export const updateStatusTotemRepository = async (totem, isToCreateLog) => {

  const { id } = totem;

  try {
    if (isToCreateLog) {
      await createLog(admin.id, id)
    }

    const newAdmin = {
      ...admin,
      selectedTotem: {
        ...totem,
      }
    }

    await adminStore.commit('setAdmin', newAdmin)

    if (isToCreateLog) router.push('/standby')
  } catch (error) {
    console.log(error)
  }
}